import React, { Component } from 'react';
import { FormFieldArea, TextFieldLabel, Label, ErrorMessage } from '../../../styles/style';
import hazard from '../../../images/hazard.png';
import { ToolTip } from './'
class TextArea extends Component {
  render() {
    let { label, content, value, name, update, onFocus, errorMessage, required, type, max, count, tooltip } = this.props;
    let rows;
    if (value) {
      rows = Math.floor(value.length / 55) + 2 + (value.match(/\n/) ? value.match(/\n/g).length : 0);
    }
    else {
      rows = 2;
    }

    return (
      <div>
        <TextFieldLabel>
          <Label required={required} htmlFor={name}>{label}</Label>
          {this.props.children}
          {errorMessage[name] && (<ErrorMessage>{errorMessage[name]}</ErrorMessage>)}
        </TextFieldLabel>
        {this.props.includeDear && (<div style={{margin: '23px 15px 10px',color: '#595959'}}>Dear [First Name],</div>)}
        <FormFieldArea value={value === null ? '' : value} 
          type={type} 
          id={name} 
          name={name} 
          onChange={update} 
          onFocus={onFocus} 
          rows={rows}
          className={value && max && (value.length > max) ? 'exceeded' : ''} />
        {count && max && (<p style={{margin: '10px 0 0 20px'}}>{value ? value.length : 0}/{max} characters {value && (value.length > max) ? (<img className="hazard" src={hazard} />) : ''}</p>)}
        
      </div>
    )
  }
}

export default TextArea;